// extracted by mini-css-extract-plugin
export default {"categoryTitle":"CategoryDetails_categoryTitle__fdRyq","breadcrumb":"CategoryDetails_breadcrumb__3B4WA"};